import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=0c48146f&scoped=true&"
import script from "./BaseFormInput.vue?vue&type=script&lang=js&"
export * from "./BaseFormInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=0c48146f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48146f",
  null
  
)

export default component.exports